import UserPrepaidCardApi from '@apis/prepaid/UserPrepaidCardApi';
import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { useFlow } from '@router/stackflow';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

import useUserPrepaidCards from '../../../hooks/useUserPrepaidCards';

function useDeleteAllPrepaidCards() {
    const { t } = useTranslation('prepaidCard');
    const { prepaidCards } = useUserPrepaidCards();
    const queryClient = useQueryClient();
    const toast = useToast();
    const { pop } = useFlow();
    const { mutate } = useMutation({
        mutationFn: UserPrepaidCardApi.deleteAllPrepaidCards,
        async onSuccess() {
            await queryClient.invalidateQueries({ queryKey: queries.userPrepaidCard._def });
            pop();
            toast.info(t('manage.delete.success'));
        },
        onError(e: AxiosError<ErrorResponse>) {
            toast.error(e.response?.data.message || t('manage.deleteAllModal.failed'));
        },
    });
    const handleDeleteAllPrepaidCards = () => {
        if (!prepaidCards || prepaidCards?.length === 0) {
            toast.info(t('manage.deleteAllModal.noCard'));
            return;
        }

        const totalBalance = prepaidCards
            .map((card) => card.balance)
            .reduce((acc, cur) => acc + cur, 0);

        if (totalBalance !== 0) {
            toast.error(t('manage.deleteAllModal.balanceError'));
            return;
        }
        mutate();
    };
    return { handleDeleteAllPrepaidCards };
}

export default useDeleteAllPrepaidCards;
